"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef, Suspense } from "react";

function ScrollRestorationContent() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const hasRestoredRef = useRef(false);
  const scrollKeyRef = useRef("");

  useEffect(() => {
    const currentScrollKey = `scrollPos:${pathname}${
      searchParams.toString() ? `?${searchParams.toString()}` : ""
    }`;
    scrollKeyRef.current = currentScrollKey;

    // Reset restoration flag when route changes
    hasRestoredRef.current = false;

    const saveScrollPosition = () => {
      sessionStorage.setItem(currentScrollKey, window.scrollY.toString());
    };

    const restoreScrollPosition = () => {
      // Prevent multiple restorations
      if (hasRestoredRef.current) return;

      const scrollPos = sessionStorage.getItem(currentScrollKey);

      if (scrollPos) {
        const targetPos = parseInt(scrollPos);

        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(() => {
          window.scrollTo({
            top: targetPos,
            behavior: "instant",
          });
          hasRestoredRef.current = true;
        });
      } else {
        // No saved position, scroll to top
        window.scrollTo(0, 0);
        hasRestoredRef.current = true;
      }
    };

    // Restore immediately on mount
    restoreScrollPosition();

    // Save scroll position before leaving
    const handleBeforeUnload = () => {
      saveScrollPosition();
    };

    // Save on scroll (throttled)
    let scrollTimeout: NodeJS.Timeout;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        saveScrollPosition();
      }, 100);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Listen for custom data loaded event
    const handleDataLoaded = () => {
      if (!hasRestoredRef.current) {
        // Small delay to ensure content is rendered
        setTimeout(restoreScrollPosition, 50);
      }
    };

    window.addEventListener("dataLoaded", handleDataLoaded);

    return () => {
      clearTimeout(scrollTimeout);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("dataLoaded", handleDataLoaded);
    };
  }, [pathname, searchParams]);

  return null;
}

// Custom event to signal when data loading is complete
export const triggerDataLoaded = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("dataLoaded"));
  }
};

export default function ScrollRestoration() {
  return (
    <Suspense fallback={null}>
      <ScrollRestorationContent />
    </Suspense>
  );
}

// "use client";

// import { usePathname, useSearchParams } from "next/navigation";
// import { useEffect, useState, Suspense } from "react";

// function ScrollRestorationContent() {
//   const pathname = usePathname();
//   const searchParams = useSearchParams();
//   const [isRestored, setIsRestored] = useState(false);

//   useEffect(() => {
//     // Only restore once per page
//     if (isRestored) return;

//     const saveScrollPosition = () => {
//       sessionStorage.setItem(
//         `scrollPos:${pathname}${
//           searchParams.toString() ? `?${searchParams.toString()}` : ""
//         }`,
//         window.scrollY.toString()
//       );
//     };

//     // Function to restore scroll position
//     const restoreScrollPosition = () => {
//       const scrollPos = sessionStorage.getItem(
//         `scrollPos:${pathname}${
//           searchParams.toString() ? `?${searchParams.toString()}` : ""
//         }`
//       );

//       if (scrollPos) {
//         window.scrollTo(0, parseInt(scrollPos));
//         setIsRestored(true);
//       }
//     };

//     // Try to restore immediately
//     restoreScrollPosition();

//     // Set up a mutation observer to detect when content has loaded
//     const observer = new MutationObserver(() => {
//       restoreScrollPosition();
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//       attributes: true,
//     });

//     // Also set a timeout as a fallback
//     const timeoutId = setTimeout(() => {
//       restoreScrollPosition();
//       observer.disconnect();
//     }, 1000);

//     // Listen for custom data loaded event
//     const handleDataLoaded = () => {
//       restoreScrollPosition();
//     };

//     window.addEventListener("dataLoaded", handleDataLoaded);

//     window.addEventListener("beforeunload", saveScrollPosition);

//     return () => {
//       clearTimeout(timeoutId);
//       observer.disconnect();
//       window.removeEventListener("beforeunload", saveScrollPosition);
//       window.removeEventListener("dataLoaded", handleDataLoaded);
//     };
//   }, [pathname, searchParams, isRestored]);

//   return null;
// }

// // Custom event to signal when data loading is complete
// export const triggerDataLoaded = () => {
//   if (typeof window !== "undefined") {
//     window.dispatchEvent(new CustomEvent("dataLoaded"));
//   }
// };

// export default function ScrollRestoration() {
//   return (
//     <Suspense fallback={null}>
//       <ScrollRestorationContent />
//     </Suspense>
//   );
// }
